// extracted by mini-css-extract-plugin
export default {"background":"specialize_background__cIod9","wrapper":"specialize_wrapper__TWnA3","title":"specialize_title__Dmz-Q"};